import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE, PHONE_HREF, CITIES, EMAIL, EMAIL_HREF } from "../lib/site";
import { SERVICES } from "../lib/services";

const Col = ({ title, children }) => (
  <div>
    <p className="mb-5 font-mono text-xs uppercase tracking-[0.25em] text-slate-400">{title}</p>
    <ul className="space-y-3 text-sm text-slate-300">{children}</ul>
  </div>
);

export const Footer = () => (
  <footer className="relative overflow-hidden bg-ink pb-28 pt-24 text-white md:pb-12" data-testid="site-footer">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="grid gap-14 md:grid-cols-12">
        <div className="md:col-span-4">
          <Logo />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-slate-400">
            A professionally managed commercial cleaning company. Recurring contracts, documented scopes, one accountable contact.
          </p>
          <a href={PHONE_HREF} data-testid="footer-call-link" className="mt-8 inline-flex items-center gap-2 font-display text-2xl transition-colors hover:text-glint">
            <Phone className="h-5 w-5" /> {PHONE}
          </a>
          <a href={EMAIL_HREF} data-testid="footer-email-link" className="mt-3 block text-sm text-slate-300 transition-colors hover:text-glint">{EMAIL}</a>
        </div>
        <div className="grid grid-cols-2 gap-10 md:col-span-8 md:grid-cols-3">
          <Col title="Services">
            {SERVICES.map((s) => (
              <li key={s.slug}><Link to={s.path} data-testid={`footer-${s.slug}`} className="transition-colors hover:text-glint">{s.nav}</Link></li>
            ))}
          </Col>
          <Col title="Company">
            <li><Link to="/about" data-testid="footer-about" className="hover:text-glint">About</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="hover:text-glint">Contact</Link></li>
            <li><Link to="/request-quote" data-testid="footer-quote" className="hover:text-glint">Request a Quote</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy" className="hover:text-glint">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms" className="hover:text-glint">Terms of Service</Link></li>
          </Col>
          <Col title="Service area">
            {CITIES.map((c) => <li key={c}>{c}, AZ</li>)}
            <li className="text-slate-400">Nearby West Valley communities</li>
          </Col>
        </div>
      </div>
      <p aria-hidden="true" className="pointer-events-none mt-20 select-none font-display text-[19vw] font-semibold leading-[0.8] tracking-tighter text-white/[0.06] md:text-[15vw]">
        Shine.
      </p>
      <div className="mt-8 flex flex-col justify-between gap-3 border-t border-white/10 pt-8 text-xs text-slate-400 md:flex-row">
        <p>© {new Date().getFullYear()} Shine Solutions. All rights reserved.</p>
        <p>Serving the Phoenix West Valley, Arizona.</p>
      </div>
    </div>
  </footer>
);
